import { combineEpics } from 'redux-observable'
import { CreateOrderEpic } from './CreateOrder/CreateOrderEpic.js'
import { CreateDatasetEpic } from './CreateDataset/CreateDatasetEpic.js'
import { SubmitOrderEpic } from './SubmitOrder/SubmitOrderEpic.js'
import { UpdateSampleEpic } from './UpdateSample/UpdateSampleEpic.js'
import { GetAllDatasetsEpic } from './GetAllDatasets/GetAllDatasetsEpic.js'
import { GetAllOrderEpic } from './GetAllOrder/GetAllOrderEpic.js'
import { GetDatasetReportEpic } from './GetDatasetReport/GetDatasetReportEpic.js'
import { requestFileUploadEpic } from './RequestFileUploadURLEpic.js'
import { PostSampleEpic } from './PostSampleEpic.js'
import { GetOrderEpic } from './GetOrderEpic.js'
import { ClaimOrderEpic } from './ClaimOrder/ClaimOrderEpic.js'
import { UpdatePoolItemEpic } from './UpdatePoolItem/UpdatePoolItemEpic.js'
import { DeleteOrderEpic } from './DeleteOrder/DeleteOrderEpic.js'
import { DeletePoolItemEpic } from './DeletePoolItem/DeletePoolItemEpic.js'
import { AttachReverseFileEpic } from './AttachReverseFile/AttachReverseFileEpic.js'
import { DeleteSamplePoolEpic } from './DeleteSamplePool/DeleteSamplePoolEpic.js'
import { UpdateSamplePoolLabelEpic } from './UpdateSamplePoolLabel/UpdateSamplePoolLabelEpic.js'
import { GetFastqEpic } from './GetFastqEpic/GetFastqEpic.js'
import { GetPipelineStateEpic } from './GetPipelineState/GetPipelineStateEpic.js'
import { GetPostprocessingDataEpic } from './GetPostprocessingData/GetPostprocessingDataEpic.js'
import { GetOtuProcessingDataEpic } from './GetOtuProcessingData/GetOtuProcessingDataEpic.js'
import { PullbackOrderEpic } from './PullbackOrder/PullbackOrderEpic.js'
import { GetPublicOrderEpic } from './GetPublicOrderEpic/GetPublicOrderEpic.js'
import { CreateOrderDraftEpic } from './CreateOrder/CreateOrderDraftEpic.js'
import { AddSampleMetaDatasEpic } from './SampleMetaData/addSampleMetaDataEpic.js'
import { GetSampleMetaDataEpic } from './SampleMetaData/GetSampleMetaDataEpic.js'
import { UpdateOrderNameEpic } from './UpdateOrderName/UpdateOrderNameEpic.js'
import { OverrideSequencingPlatformEpic } from './OverrideSequencingPlatform/OverrideSequencingPlatformEpic.js'
import { GetOtuCountEpic } from './GetOtuCount/GetOtuCountEpic.js'
import { InviteLabEpic } from './CreateOrder/InviteLabEpic.ts'
import { BatchUpdateSamplesEpic } from './BatchUpdateSamples/BatchUpdateSamplesEpic.js'
import { MovePoolItemsEpic } from './MovePoolItems/MovePoolItemsEpic.js'
import { ApplySheetImportEpic } from './ApplySheetImport/ApplySheetImportEpic.ts'
import { ListFilesEpic } from './ListFiles/ListFilesEpic.js'
import { ConvertPoolItemEpic } from './SampleConversion/ConvertPoolItemEpic.js'
import { DeleteMetadataEpic } from './DeleteMetadataEpic/DeleteMetadataEpic.js'
import { UnlinkMetadataEpic } from './UnlinkMetadataEpic/UnlinkMetadataEpic.js'
import { UpdatePrimersForSubmitEpic } from './UpdatePrimersForSubmit/UpdatePrimersForSubmitEpic.js'
import { GetProjectReportEpic } from '../Project/GetProjectReportEpic.js'
import { SubmitPostprocessingEpic } from './SubmitPostprocessing/SubmitPostprocessingEpic.js'
import { DownloadOrderArtifactEpic } from './DownloadOrderArtifact/DownloadOrderArtifactEpic.js'
import { GetIntermediatesStatusEpic } from './GetIntermediatesStatus/GetIntermediatesStatusEpic.js'
import { GetOrderNoticesEpic } from './GetOrderNotices/GetOrderNoticesEpic.js'
import { RerunPreprocessingEpic } from './RerunPreprocessing/RerunPreprocessingEpic.js'
import { GetReprocessingGrantEpic } from './GetReprocessingGrant/GetReprocessingGrantEpic.js'

export const orderEpics = combineEpics(
  ClaimOrderEpic,
  CreateOrderEpic,
  CreateDatasetEpic,
  SubmitOrderEpic,
  UpdateSampleEpic,
  GetAllOrderEpic,
  GetDatasetReportEpic,
  GetAllDatasetsEpic,
  requestFileUploadEpic,
  PostSampleEpic,
  GetOrderEpic,
  UpdatePoolItemEpic,
  DeleteOrderEpic,
  DeletePoolItemEpic,
  AttachReverseFileEpic,
  DeleteSamplePoolEpic,
  UpdateSamplePoolLabelEpic,
  GetFastqEpic,
  GetPipelineStateEpic,
  GetPostprocessingDataEpic,
  GetOtuProcessingDataEpic,
  PullbackOrderEpic,
  GetPublicOrderEpic,
  CreateOrderDraftEpic,
  AddSampleMetaDatasEpic,
  GetSampleMetaDataEpic,
  UpdateOrderNameEpic,
  OverrideSequencingPlatformEpic,
  GetOtuCountEpic,
  InviteLabEpic,
  BatchUpdateSamplesEpic,
  MovePoolItemsEpic,
  ApplySheetImportEpic,
  ListFilesEpic,
  ConvertPoolItemEpic,
  UpdatePrimersForSubmitEpic,
  DeleteMetadataEpic,
  UnlinkMetadataEpic,
  GetProjectReportEpic,
  SubmitPostprocessingEpic,
  DownloadOrderArtifactEpic,
  GetIntermediatesStatusEpic,
  GetOrderNoticesEpic,
  RerunPreprocessingEpic,
  GetReprocessingGrantEpic
)
